import { useState, useEffect } from 'react';
import { getDomain } from '../../../../../services/utils';
import UserRoleEnum from '../../../../../constants/UserRoleEnum';
import { hasAccessRole } from '../../../../../services/utils';

const INITIAL_CREDIT_CARD_DETAILS = {
  number: '',
  name: '',
  expiry: '',
  cvc: '',
  focused: 'number',
  paymentMethodId: 'cash',
  installments: 1,
  docType: 'DNI'
};

/**
 * Manages payment method selection, bank details,
 * credit card details, and auto-pay for campaigns with external DSP.
 */
const usePaymentMethod = ({
  campaign,
  currency,
  paymentMethods,
  isSuperUser,
  user,
  makePayment
}) => {
  const domain = getDomain(window.location.hostname);
  const [paymentMethodSelected, setPaymentMethodSelected] = useState('other');
  const [creditCardDetails, setCreditCardDetails] = useState({ ...INITIAL_CREDIT_CARD_DETAILS });
  const [bankData, setBankData] = useState([]);
  const [createdPaymentAuthomatic, setCreatedPaymentAuthomatic] = useState(false);

  const handleSelectPaymentMethod = paymentMethodId => {
    if (paymentMethodId !== 'credit_account') {
      setCreditCardDetails(prev => ({ ...prev, paymentMethodId }));
    } else {
      setCreditCardDetails(prev => ({ ...prev, paymentMethodId: 'credit_account' }));
    }
  };

  const selectPaymentMethodSelected = value => {
    let paymentMethod;

    if (value === 'card') {
      paymentMethod = paymentMethods.find(pm => pm.id === 'credit_account');
    }

    if (
      value === 'other' &&
      user &&
      hasAccessRole(user.roles, [UserRoleEnum.agencyMember, UserRoleEnum.companyMember])
    ) {
      paymentMethod = paymentMethods.find(pm => pm.id === 'credit_account');
    }

    if (!paymentMethod) {
      paymentMethod = paymentMethods.find(pm => pm.id === 'cash');
    }

    setPaymentMethodSelected(value);
    setCreditCardDetails({
      ...INITIAL_CREDIT_CARD_DETAILS,
      paymentMethodId: paymentMethod ? paymentMethod.id : 'cash'
    });
  };

  // Set up bank details, default payment method, and DSP auto-pay
  useEffect(() => {
    if (!campaign || !campaign.id) return;

    // Bank data
    let data = [];
    if (domain === 'duoPrint') {
      data = '\n Banco Pichincha \n Cuenta Corriente: 3470813004 \n email: cobranzas@duoprint.com.ec \n\n\n  Banco Internacional \n Cuenta Corriente: 1400612058 \n email: cobranzas@duoprint.com.ec'.split(
        /\n/
      );
    } else if (
      campaign.invoice_issuing &&
      campaign.invoice_issuing.business &&
      campaign.invoice_issuing.business.bank_details
    ) {
      data = campaign.invoice_issuing.business.bank_details.split(/\n/);
    }
    setBankData(data);

    // Default payment method
    if (
      (domain === 'latinad' && campaign.currency !== 'ARS') ||
      (!campaign.currency && currency && currency !== 'ARS')
    ) {
      handleSelectPaymentMethod('transfer');
    }
    if (domain !== 'latinad') {
      handleSelectPaymentMethod('cash');
    }

    // Auto-payment for campaigns with external DSP
    if (
      campaign.external_dsp_id != null &&
      !!campaign.smart_campaign &&
      !isSuperUser &&
      campaign.payment_status === 'pending' &&
      !createdPaymentAuthomatic
    ) {
      setCreatedPaymentAuthomatic(true);
      setPaymentMethodSelected('transfer');
      makePayment();
    } else {
      setPaymentMethodSelected('other');
    }
  }, [campaign]);

  return {
    paymentMethodSelected,
    setPaymentMethodSelected,
    selectPaymentMethodSelected,
    creditCardDetails,
    setCreditCardDetails,
    handleSelectPaymentMethod,
    bankData,
    domain
  };
};

export { INITIAL_CREDIT_CARD_DETAILS };
export default usePaymentMethod;
